<template>
    <div class="individual">
        <div class="individual-box">
            <div class="individual-tit">
                <span class="individual-tit-line"></span>
                <span class="individual-tit-bold">绑定信息</span>
            </div>

            <div class="bind-box">
                <div class="bind-phone">
                    <div class="bind-box-list">
                        <img class="bind-box-icon" :src="telIcon" alt="">
                        <div class="bind-box-info">
                            <div class="bind-box-info-left">
                                <p class="bind-box-info-left-tit">
                                    手机绑定
                                </p>
                                <p class="bind-box-info-left-explain">
                                    可以使用手机{{ phone }}快捷登录
                                </p>
                            </div>
                            <div class="bind-box-info-right" @click="bindPhoneBtn()">
                                修改绑定
                            </div>
                        </div>
                    </div>

                    <div class="bind-phone-bottom" v-show="showChange">
                        <div class="bind-phone-bottom-box" v-show="stepOne">
                            <p class="bind-phone-title">为了您的账号安全，需要验证当前手机</p>
                            <div class="old-phone">
                                <span class="old-phone-span">原手机号码：</span>
                                <input readonly type="text" v-model="phone">
                            </div>

                            <div class="old-phone-yz">
                                <span class="old-phone-span">验证码：</span>
                                <div class="old-phone-yz-box">
                                    <input type="text" v-model="yzCode">
                                    <div class="getCode">
                                        <span class="getCodeBtn" v-show="!sendSuccess"
                                              @click="getCodeChange()">获取验证码</span>
                                        <span class="getCodeTime" v-show="sendSuccess">
                                            发送成功{{(sixten) }}s
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <div class="changeNext" @click="changeNext()">
                                <span>下一步</span>
                            </div>
                        </div>


                        <div class="bind-phone-bottom-box" v-show="stepTwo">
                            <div class="old-phone">
                                <span class="old-phone-span">新手机号：</span>
                                <input type="text" v-model="newPhone">
                            </div>

                            <div class="old-phone-yz">
                                <span class="old-phone-span">验证码：</span>
                                <div class="old-phone-yz-box">
                                    <input type="text" v-model="newCode">
                                    <div class="getCode">
                                        <span class="getCodeBtn" v-show="!sendSuccessNew"
                                              @click="getCodeChangeNew()">获取验证码</span>
                                        <span class="getCodeTime" v-show="sendSuccessNew">
                                            发送成功({{ sixtenNew }})s
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <div class="changeNext" @click="finishBind()">
                                <span>完成绑定</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="bind-box-list">
                    <img class="bind-box-icon" :src="weixinIcon" alt="">
                    <div class="bind-box-info">
                        <div class="bind-box-info-left">
                            <p class="bind-box-info-left-tit">
                                微信绑定
                            </p>
                            <p class="bind-box-info-left-explain">
                                绑定后可使用微信直接扫码登录
                            </p>
                        </div>
                        <div class="bind-box-info-right">
                            未开发
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "binding",
        data() {
            return {
                telIcon: require('@/assets/images/persondata/personal_icon_shouji01.png'),
                weixinIcon: require('@/assets/images/persondata/personal_icon_weixin01.png'),
                phoneAll: '',
                phone: '',
                pwd: '',
                yzCode: '',
                stepOne: true,
                stepTwo: false,
                sendSuccess: false, //短信是否发送成功
                sixten: 60, //60秒倒计时
                showChange: false,
                newPhone: '',
                newCode: '',
                sendSuccessNew: false,
                sixtenNew: 60, //60秒倒计时
            }
        },
        methods: {
            myBaseInfo() {
                this.$axios.get("/myBaseInfo").then((res) => {
                    // console.log(res);
                    res = res.data;
                    if (res.status == 200) {
                        this.phoneAll = res.data.phone;
                        this.phone = res.data.phone.substr(0, 3) + '****' + res.data.phone.substring(7, 11)
                    } else {
                        // layer.msg(res.msg, {icon: 2});
                        this.$message(res.msg);
                    }//请求成功返回的数据
                })
            },
            bindPhoneBtn() {
                this.showChange = true;
            },

            changeNext() {
                var oldCode = this.yzCode;
                if (oldCode.length < 1) {
                    // layer.msg('请输入短信验证码', {
                    //     icon: 2
                    // });

                    this.$message('请输入短信验证码');
                    return;
                }

                var index;
                /*layui.use('layer', function () {
                    var layer = layui.layer;
                    index = layer.load(1, {
                        shade: [0.1, '#fff'] //0.1透明度的白色背景
                    });
                });*/

                this.$axios.post("/checkAccountMobile", {
                    verifyCode: oldCode,
                }).then((res) => {
                    res = res.data;
                    if (res.status == 200) {
                        // layer.close(index);
                        this.stepOne = false;
                        this.stepTwo = true;
                    } else {
                        // layer.close(index);
                        layer.msg(res.message, {icon: 2});
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },

            finishBind(){
                var newPhone = this.newPhone;
                var newCode = this.newCode;

                if (newCode.length < 1) {
                   /* layer.msg('请输入短信验证码', {
                        icon: 2
                    });*/
                    this.$message('请输入短信验证码');
                    return;
                }

                var index;
                /*layui.use('layer', function () {
                    var layer = layui.layer;
                    index = layer.load(1, {
                        shade: [0.1, '#fff'] //0.1透明度的白色背景
                    });
                });*/

                this.$axios.post("/changeAccountMobile", {
                    newPhone: newPhone,
                    verifyCode: newCode,
                }).then((res) => {
                    res = res.data;
                    console.log(res);
                    if (res.status == 200) {
                        // layer.close(index);
                        this.stepOne = true;
                        this.stepTwo = false;
                        this.showChange = false;
                        this.$router.push({path: '/persondatahome'});
                        // layer.msg('修改绑定成功',{icon: 1});
                        this.$message('修改绑定成功');
                    } else {
                        // layer.close(index);
                        // layer.msg(res.message, {icon: 2});
                        this.$message(res.message);
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },

            /*发送验证码时，开始计数，一分钟发送一次*/
            getCodeChange() {
                var that = this;
                var phone = that.phoneAll; //手机号码
                var yzCode = that.yzCode;

                that.$axios.post("/getVerfyCode", {
                    phone: phone,
                    use_type: yzCode
                }).then((res) => {
                    res = res.data;
                    if (res.status == 200) {
                        // layer.closeAll();
                        // layer.msg(res.message);
                        this.$message(res.message);
                        that.sendSuccess = true;
                        //倒计时
                        that.time_down();
                    } else {
                        // layer.closeAll();
                        // layer.msg(res.message, {icon: 2});
                        this.$message(res.message);
                    }
                }).catch((error) => {
                    // layer.closeAll();
                    // layer.msg('系统错误', {
                    //     icon: 2
                    // });
                    this.$message('系统错误');
                });
            },

            /*发送验证码时，开始计数，一分钟发送一次*/
            getCodeChangeNew() {
                var that = this;
                var newPhone = that.newPhone; //手机号码
                var newCode = that.newCode;

                var myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
                if (!myreg.test(newPhone)) {
                    /*layer.msg('请输入正确的手机号码！', {
                        icon: 2
                    });*/
                    this.$message('请输入正确的手机号码！');
                    return;
                }

                var index;
                /*layui.use('layer', function () {
                    var layer = layui.layer;
                    index = layer.load(1, {
                        shade: [0.1, '#fff'] //0.1透明度的白色背景
                    });
                });*/

                that.$axios.post("/getVerfyCode", {
                    phone: newPhone,
                    use_type: newCode
                }).then((res) => {
                    res = res.data;
                    console.log(res);
                    if (res.status == 200) {
                        // layer.closeAll();
                        // layer.msg(res.message);
                        this.$message(res.message);
                        that.sendSuccessNew = true;
                        //倒计时
                        that.time_down_new();
                    } else {
                        // layer.closeAll();
                        // layer.msg(res.message, {icon: 2});
                        this.$message(res.message);
                    }
                }).catch((error) => {
                    /*layer.closeAll();
                    layer.msg('系统错误', {
                        icon: 2
                    });*/
                    this.$message('系统错误');
                });
            },

            //倒计时注册
            time_down() {
                var that = this;
                //记录点击时间
                var t1 = window.setInterval(function () {
                    var num = that.sixten;
                    num = num - 1;
                    if (num < 1) {
                        that.sendSuccess = false;
                        window.clearInterval(t1);
                        that.sixten = 60;
                    } else {
                        that.sixten = num;
                    }
                }, 1000);
            },

            //倒计时注册
            time_down_new() {
                var that = this;
                //记录点击时间
                var t2 = window.setInterval(function () {
                    var num = that.sixtenNew;
                    num = num - 1;
                    if (num < 1) {
                        that.sendSuccessNew = false;
                        window.clearInterval(t2);
                        that.sixtenNew = 60;
                    } else {
                        that.sixtenNew = num;
                    }
                }, 1000);
            },
        },
        mounted() {
            this.myBaseInfo();
        },

    }
</script>

<style scoped>
    .individual {
        width: 998px;
        border: 1px solid #EEEEEE;
    }

    .individual-box {
        width: 958px;
        margin: 0 auto;
        display: flex;
        flex-direction: column;
    }

    .individual-tit {
        height: 49px;
        border-bottom: 1px solid #EEEEEE;
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .individual-tit-line {
        width: 2px;
        height: 14px;
        background: #FF5227;
    }

    .individual-tit-bold {
        margin-left: 10px;
        height: 20px;
        line-height: 20px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #333333;
    }

    .bind-box {
        width: 958px;
        margin-top: 40px;
        margin-bottom: 40px;
    }

    .bind-phone {
        margin-bottom: 30px;
    }

    .bind-box-list {
        width: 956px;
        height: 90px;
        border: 1px solid #EEEEEE;
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .bind-box-icon {
        width: 46px;
        height: 46px;
        margin-left: 28px;
    }

    .bind-box-info {
        margin-left: 14px;
        width: 820px;
        height: 90px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    }

    .bind-box-info-left {
        height: 50px;
    }

    .bind-box-info-left-tit {
        height: 24px;
        line-height: 24px;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #1C1C1C;
    }

    .bind-box-info-left-explain {
        height: 20px;
        line-height: 20px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666;
        margin-top: 4px;
    }

    .bind-box-info-right {
        width: 80px;
        height: 30px;
        line-height: 30px;
        border: 1px solid #F24918;
        border-radius: 2px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #FF5227;
        text-align: center;
        cursor: pointer;
    }

    .bind-phone-bottom {
        width: 600px;
        margin: 0 auto;
    }

    .bind-phone-bottom-box {
        margin-top: 20px;
        width: 100%;
    }

    .bind-phone-title {
        width: 300px;
        height: 20px;
        line-height: 20px;
        text-align: left;
        margin: 0 auto;
        color: #F24918;
    }

    .old-phone {
        width: 400px;
        margin: 20px auto 0;
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .old-phone-span {
        width: 85px;
        height: 30px;
        line-height: 30px;
    }

    .old-phone input {
        width: 180px;
        height: 30px;
        line-height: 30px;
        border: 1px solid #999;
        border-radius: 4px;
        padding-left: 6px;
    }

    .old-phone-yz {
        width: 400px;
        margin: 20px auto 0;
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .old-phone-yz-box {
        width: 186px;
        height: 30px;
        line-height: 30px;
        border: 1px solid #999;
        border-radius: 4px;
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .old-phone-yz-box input {
        width: 80px;
        height: 26px;
        line-height: 26px;
        border: none;
        padding: 0 0 0 4px;
        margin: 0 0 0 2px;
    }

    .getCode {
        width: 100px;
        height: 28px;
        line-height: 28px;
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
    }

    .getCodeBtn {
        width: 80px;
        height: 28px;
        line-height: 28px;
        cursor: pointer;
        color: #F24918;
        font-size: 14px;
        font-family: Microsoft YaHei;
    }

    .getCodeTime {
        color: #FF5227;
        font-size: 14px;
        font-family: Microsoft YaHei;
    }

    .changeNext {
        width: 400px;
        margin: 20px auto 0;
        display: flex;
        flex-direction: row;
    }

    .changeNext span {
        display: block;
        width: 80px;
        height: 24px;
        line-height: 24px;
        background: #FF5227;
        text-align: center;
        color: #fff;
        font-size: 14px;
        cursor: pointer;
        border-radius: 4px;
    }

</style>



// WEBPACK FOOTER //
// src/pages/persondata/children/binding.vue